import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <p className="font-heading text-8xl font-black text-background-200 select-none md:text-[10rem]">
        404
      </p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">这条线索暂时断掉了</h1>
      <p className="mt-3 text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
        你要找的页面可能已经调整或不存在。可以先回首页，或者去档案库翻翻其他事件复盘。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/archive"
          className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
        >
          浏览事件档案
        </Link>
      </div>
    </div>
  );
}